<template>
  <div
      class="flex bg-surface-active border border-accent items-center justify-center text-accent dark:text-white cursor-default w-14 h-20 text-center shadow-md text-2xl font-bold align-middle rounded-lg">
    <slot></slot>
  </div>
</template>
